import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { ReactComponent as IAMLogo } from 'src/images/iam_logo.svg';
import { ReactComponent as IAMLogoWhite } from 'src/images/iam_logo_w.svg';
import { useHistory } from 'react-router';
import ReactGA from 'react-ga4';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '0 16px 0 80px',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: '#fff',
    zIndex: 3
  },
  openWrapper: {
    marginLeft: 185,
    padding: '0 1rem 0 2rem',
    width: 'calc(100% - 185px)',
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: '#fff',
    zIndex: 99
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontFamily: 'Archivo',
    color: '#000',
    fontSize: 26,
    fontWeight: 500
  },
  subTitle: {
    fontFamily: 'Archivo',
    color: '#9a9a9a',
    fontSize: 16,
    fontWeight: 400
  },

  hr: {
    height: 1,
    border: 0,
    backgroundColor: '#D9D9D9'
  },

  logo: {
    width: 64,
    height: 24,
    color: 'white',
    cursor: 'pointer'
  }
}));

const GuestHeader = ({ onClickLogoGuest, style, isBlack }) => {
  const classes = useStyles();
  const history = useHistory();

  const onClickTrialButton = () => {
    ReactGA.event('trial_click', {
      value: `location ${window.location.pathname}`
    });
    history.push('/register');
  };
  const onClickLoginButton = () => {
    ReactGA.event('trial_login_click', {
      value: `location ${window.location.pathname}`
    });
    history.push('/login');
  };
  return (
    <Box
      style={{
        height: '70px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minWidth: 500,
        backgroundColor: style.background,
        padding: isBlack ? '0 30px' : '0'
      }}
    >
      {isBlack ? (
        <IAMLogoWhite className={classes.logo} onClick={onClickLogoGuest} />
      ) : (
        <IAMLogo className={classes.logo} onClick={onClickLogoGuest} />
      )}
      <div
        style={{
          fontSize: 16,
          fontWeight: 700,
          fontFamily: 'Archivo',
          minWidth: 350,
          color: `${style.color || 'black'}`
        }}
      >
        <span>Try all features for </span>
        <span style={{ color: '#4778FF', marginRight: 20 }}>14 days</span>
        <button
          onClick={onClickTrialButton}
          style={{
            width: '129px',
            height: '37px',
            background: 'linear-gradient(to right, #0F0F33, #2367FF)',
            borderRadius: '5px',
            border: 'none',
            color: 'white',
            fontSize: '16px',
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'Archivo'
          }}
        >
          Start free trial
        </button>
      </div>
      <button
        onClick={onClickLoginButton}
        style={{
          border: `1px solid ${style.border || '#939393'}`,
          height: 37,
          width: 71,
          borderRadius: 67,
          color: `${style.buttonColor || '#939393'} `,
          background: `${style.buttonBackground || 'none'}`,
          cursor: 'pointer'
        }}
      >
        LOGIN
      </button>
    </Box>
  );
};
export default GuestHeader;
